<template>
	<n-tooltip class="text-fs-xs! px-1.5! py-1!">
		<template #trigger>
			<n-tag :round :color="{ color: 'transparent' }" :size class="text-fs-sm font-normal">
				<template v-if="icon" #icon>
					<Icon :name="icon" :size="sizePX" />
				</template>
				{{ label }}
			</n-tag>
		</template>
		{{ $t(`patients.tags.last_period`) }}
	</n-tooltip>
</template>

<script setup lang="ts">
import type { PatientMeta } from "@/types/patient"
import { NTag, NTooltip } from "naive-ui"
import { computed } from "vue"
import Icon from "@/components/common/Icon.vue"
import { ICONS } from "@/const"
import { dFormat } from "@/utils/dayjs"

const { meta, size } = defineProps<{
	meta: PatientMeta
	round?: boolean
	size?: "small" | "medium" | "large" | "tiny"
}>()

const sizePX = computed(() => (size === "small" ? 12 : size === "large" ? 16 : size === "tiny" ? 10 : 14))

const label = computed(() => dFormat(meta.last_period, "date"))

const icon = computed(() => ICONS.date)
</script>
